import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class IncidentService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
	}

	public getAll(rec) {
		return this.http.post(environment.apiurl + "/Incidents/log?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public details(obj) {
		return this.http.post(environment.apiurl + "/Medicines/details?access_token=" + this.globalCfgService.getAccessToken() , obj);
	}

	getHeatmapData(obj) {
		return this.http.post(environment.apiurl + "/Incidents/heatmap?access_token=" + this.globalCfgService.getAccessToken() , obj);
	}
	
	getProvenance(incidentId) {
		return this.http.get(environment.apiurl + "/Incidents/provenance?access_token=" + this.globalCfgService.getAccessToken() + '&incidentId=' + incidentId);
	}
}

	

